const ShapeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7" cy="16" r="6" stroke="currentColor" strokeWidth="2" />
      <path
        d="M15.6338 7.5C16.0187 6.83333 16.9813 6.83333 17.3662 7.5L22.9951 17.25C23.38 17.9167 22.8987 18.75 22.1289 18.75H13.4385C13.7058 18.1248 13.8851 17.4531 13.96 16.75H20.3965L16.5 10L13.8555 14.5801C13.6807 13.7316 13.351 12.9403 12.8994 12.2344L15.6338 7.5Z"
        fill="currentColor"
      />
      <path
        d="M14.2041 1.01074C15.2128 1.113 16 1.96435 16 3V10.2559C15.1926 10.8192 14.5094 11.5479 14 12.3936V3H7V9C6.30491 9 5.6338 9.10236 5 9.29102V3C5 1.89543 5.89543 1 7 1H14L14.2041 1.01074Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ShapeIcon;
